import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── Safari/iPhone Auth Fix ──
// Safari ITP blocks cross-origin cookies, so cookie-based auth fails silently.
// This interceptor injects the Bearer token (from localStorage) into ALL /api/ calls,
// ensuring authenticated requests work on Safari/iOS without modifying 40+ fetch calls.
const _originalFetch = window.fetch;
window.fetch = function (url, options = {}) {
  if (typeof url === 'string' && url.includes('/api/')) {
    const token = localStorage.getItem('fq_auth_token');
    if (token) {
      const headers = new Headers(options.headers || {});
      if (!headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      options = { ...options, headers };
    }
  }
  return _originalFetch.call(this, url, options);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ── Service Worker Registration ──
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      console.log('SW registered:', reg.scope);

      // Pre-cache key API routes after page settles
      setTimeout(() => {
        if (reg.active) {
          const base = process.env.REACT_APP_BACKEND_URL || '';
          reg.active.postMessage({
            type: 'PRECACHE_API',
            urls: [
              `${base}/api/surprise-me?location=&mode=dine-out`,
              `${base}/api/surprise-me?location=&mode=order-in`,
              `${base}/api/surprise-me?location=&mode=prepare-it`,
            ],
          });
        }
      }, 10000); // 10s after load — don't compete with critical resources
    }).catch((err) => {
      console.warn('SW registration failed:', err);
    });
  });
}
